/* =========================
   Initialize on Page Load
========================= */

window.addEventListener("load", () => {
  const embroideryCustomizer = document.querySelector(".embroidery-customizer");

  if (!embroideryCustomizer) return;

  initializeCustomizer(embroideryCustomizer);
});

/* =========================
   Utility Helpers
========================= */

function resetRadios(radios, except) {
  radios.forEach((radio) => {
    if (radio !== except) {
      radio.checked = false;
    }
  });
}

function getDefaultLogoPlacement() {
  const raw = window.EmbroideryCustomizer?.settings?.default_position;
  return String(raw).toUpperCase() === "LEFT" ? "left" : "right";
}

function resetState(state) {
  state.hasLogo = false;
  state.hasEmbroidery = false;
  state.numberOfLines = 0;
  state.logoPlacement = getDefaultLogoPlacement();
  state.textPlacement = "none";
  state.font = "Arial";
  state.color = "Black";
  state.selectedLogoImage = "";
  state.selectedLogoName = "";
  state.uploadedLogoImage = "";
  state.selectedCategories = {};
  state.textLines = {
    line1: "",
    line2: "",
    line3: "",
  };
}

function resetUIOnLoad(elements) {
  // Reset embroidery type checkboxes
  elements.embroideryTypeCheckboxes.forEach((checkbox) => {
    checkbox.checked = false;
  });

  // Reset embroidery line radios
  elements.embroideryOptionsRadios.forEach((radio) => {
    radio.checked = false;
  });

  // Reset text position checkbox
  if (elements.textPositionCheckbox) {
    elements.textPositionCheckbox.checked = true;
  }

  // Reset font selector
  if (elements.fontSelector) {
    elements.fontSelector.selectedIndex = 0;
  }

  // Reset color selector
  const colorSelector = elements.customizer.querySelector("#color");
  if (colorSelector) {
    colorSelector.selectedIndex = 0;
  }

  // Reset line inputs
  elements.embroideryLineInputs.forEach((line) => {
    const input = line.querySelector("input");
    if (input) input.value = "";
    line.hidden = true;
  });

  // Reset logo UI
  if (elements.logoOptions) {
    elements.logoOptions.querySelectorAll(".logo-category-radio").forEach((radio) => {
      radio.checked = false;
    });
    elements.logoOptions.querySelectorAll(".logo-category-select").forEach((select) => {
      select.value = "";
      select.disabled = true;
    });
    elements.logoOptions.querySelectorAll(".position-checkbox").forEach((checkbox) => {
      checkbox.checked = getDefaultLogoPlacement() === "right";
      checkbox.disabled = true;
    });
    elements.logoOptions.querySelectorAll(".logo-category-preview").forEach((preview) => {
      preview.style.backgroundImage = "";
    });
    elements.logoOptions.querySelectorAll(".logo-position-section").forEach((section) => {
      section.hidden = true;
    });

    // Reset upload input and filename
    const uploadInput = elements.logoOptions.querySelector(".logo-upload-input");
    const uploadFilename = elements.logoOptions.querySelector(".logo-upload-filename");
    const uploadPreview = elements.logoOptions.querySelector(".logo-upload-preview");
    if (uploadInput) uploadInput.value = "";
    if (uploadFilename) uploadFilename.textContent = "";
    if (uploadPreview) {
      uploadPreview.innerHTML = "";
      uploadPreview.style.backgroundImage = "";
    }
  }

  // Hide options sections
  elements.logoOptions.hidden = true;
  elements.embroideryOptions.hidden = true;
  elements.embroideryLineInputsContainer.hidden = true;
  elements.settings.hidden = true;
  elements.preview.hidden = true;

  // Reset text position section
  if (elements.textPositionSection) {
    elements.textPositionSection.hidden = true;
  }

  // Clear preview content
  elements.previewText.innerHTML = "";
  elements.previewLogo.innerHTML = "";

  // Hide disclaimer
  if (elements.disclaimer) {
    elements.disclaimer.classList.remove("is-visible");
  }

  const indicators = elements.customizer.querySelectorAll(".embroidery-option-indicator");
  indicators.forEach((indicator) => {
    indicator.textContent = "";
    indicator.hidden = true;
  });
}

function getPlacementCoords(placement) {
  const defaults = {
    x: 50,
    y: 50,
  };

  if (!placement) {
    return defaults;
  }

  if (
    typeof placement === "object" &&
    placement.x !== undefined &&
    placement.y !== undefined
  ) {
    return placement;
  }

  return defaults;
}

function applyPlacementStyles(element, coords, offsetY = 0) {
  const x = typeof coords.x === "number" ? coords.x : 50;
  const y = typeof coords.y === "number" ? coords.y : 50;

  element.style.left = `${x}%`;
  element.style.top = `${y + offsetY}%`;
  element.style.transform = "translate(-50%, -50%)";
}

/* =========================
   Cart Operations
========================= */

function updateEmbroideryProductQuantity(variantId, quantity) {
  if (quantity <= 0) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .catch((error) =>
        console.error("Error removing embroidery product:", error),
      );
  }

  return fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
    }),
  })
    .then((response) => response.json())
    .catch((error) =>
      console.error("Error updating embroidery product quantity:", error),
    );
}

/* =========================
   Properties & Customization
========================= */

function getEmbroideryProperties(state) {
  const properties = {};

  // Add embroidery properties if text exists
  if (state.numberOfLines > 0) {
    properties["Font"] = state.font;
    properties["Thread Color"] = state.color;
    properties["Text Position"] = state.textPlacement === "left" ? "Left" : "Right";

    for (let i = 1; i <= state.numberOfLines; i++) {
      const lineText = state.textLines[`line${i}`] || "";
      if (lineText) {
        properties[`Line ${i}`] = lineText;
      }
    }
  }

  // Add logo properties if logo exists
  if (state.selectedLogoImage || state.uploadedLogoImage) {
    properties["Logo Position"] = state.logoPlacement === "left" ? "Left" : "Right";

    if (
      state.selectedLogoImage &&
      Object.keys(state.selectedCategories).length > 0
    ) {
      const categoryName = Object.keys(state.selectedCategories)[0];
      const logoName = state.selectedCategories[categoryName];

      properties["Logo"] = `${categoryName} - ${logoName}`;
    }

    if (state.uploadedLogoImage) {
      properties["Logo Image"] = state.uploadedLogoImage === "digitizing" ? "Logo Digitizing Service" : state.uploadedLogoImage;
      properties["Custom Logo"] = "Yes";
    }
  }

  return properties;
}

/* =========================
   UI State Management
========================= */

function changeNumberOfLines(state, elements, currentOption) {
  state.numberOfLines = parseInt(currentOption.dataset.embroideryLine, 10);

  elements.embroideryLineInputsContainer.hidden = state.numberOfLines === 0;
  
  // Show/hide text position section based on number of lines and logo presence
  if (state.numberOfLines > 0 && !(state.selectedLogoImage || state.uploadedLogoImage)) {
    if (state.textPlacement === "none") state.textPlacement = "left";
    elements.textPositionSection.hidden = false;
    if (elements.textPositionCheckbox) {
      elements.textPositionCheckbox.checked = state.textPlacement === "right";
      elements.textPositionCheckbox.disabled = false;
    }
  } else {
    elements.textPositionSection.hidden = true;
    if (elements.textPositionCheckbox) {
      elements.textPositionCheckbox.disabled = true;
    }
  }

  for (let i = state.numberOfLines + 1; i <= 3; i++) {
    state.textLines[`line${i}`] = "";
  }

  elements.embroideryLineInputs.forEach((line, idx) => {
    const isVisible = idx < state.numberOfLines;
    line.hidden = !isVisible;

    if (!isVisible) {
      const input = line.querySelector("input");
      if (input) input.value = "";
    }
  });

  updatePreviewText(state, elements);
  updatePreviewWithPlacement(state, elements);
  updateSummaryIndicator(state, elements);
}

function updateSummaryIndicator(state, elements) {
  const logoIndicator = elements.customizer.querySelector(
    '.embroidery-option-indicator[data-indicator-type="logo"]'
  );
  const embroideryIndicator = elements.customizer.querySelector(
    '.embroidery-option-indicator[data-indicator-type="embroidery"]'
  );

  // Update logo indicator
  if (logoIndicator) {
    if (state.selectedLogoImage || state.uploadedLogoImage) {
      let logoText = "";
      if (state.uploadedLogoImage) {
        logoText = "Custom Logo";
      } else if (Object.keys(state.selectedCategories).length > 0) {
        const categoryName = Object.keys(state.selectedCategories)[0];
        const logoName = state.selectedCategories[categoryName];
        logoText = logoName.length > 15 ? logoName.substring(0, 15) + "..." : logoName;
      }
      if (logoText) {
        logoIndicator.textContent = `— ${logoText}`;
        logoIndicator.hidden = false;
      } else {
        logoIndicator.textContent = "";
        logoIndicator.hidden = true;
      }
    } else {
      logoIndicator.textContent = "";
      logoIndicator.hidden = true;
    }
  }

  // Update embroidery indicator
  if (embroideryIndicator) {
    if (state.numberOfLines > 0) {
      const textLines = [];
      for (let i = 1; i <= state.numberOfLines; i++) {
        if (state.textLines[`line${i}`]) {
          textLines.push(state.textLines[`line${i}`]);
        }
      }
      let embroideryText = "";
      if (textLines.length > 0) {
        const firstLine = textLines[0];
        const displayText = firstLine.length > 15 ? firstLine.substring(0, 15) + "..." : firstLine;
        embroideryText = `"${displayText}"`;
        if (textLines.length > 1) {
          embroideryText += ` +${textLines.length - 1} more`;
        }
      } else {
        embroideryText = `${state.numberOfLines} line${state.numberOfLines > 1 ? "s" : ""}`;
      }
      embroideryIndicator.textContent = `— ${embroideryText}`;
      embroideryIndicator.hidden = false;
    } else {
      embroideryIndicator.textContent = "";
      embroideryIndicator.hidden = true;
    }
  }
}

function updateHelpTextVisibility(state, elements) {
  const helpText = elements.customizer.querySelector(
    ".embroidery-customizer__help",
  );
  if (!helpText) return;

  if (state.numberOfLines > 0) {
    helpText.classList.add("is-visible");
  } else {
    helpText.classList.remove("is-visible");
  }
}

function updatePreviewText(state, elements) {
  const lines = [];
  for (let i = 1; i <= state.numberOfLines; i++) {
    const lineKey = `line${i}`;
    if (state.textLines[lineKey]) {
      lines.push(state.textLines[lineKey]);
    }
  }

  const containerWidth = elements.previewContainer.offsetWidth;
  const baseFontSize = window.EmbroideryCustomizer.settings.font_size || 16;
  const scaledFontSize = (containerWidth / 400) * baseFontSize; 
  const fontSize = scaledFontSize + "px";
  elements.previewText.innerHTML = lines
    .map((line) => `<p>${line}</p>`)
    .join("");
  elements.previewText.style.fontFamily = `'${state.font}'`;
  elements.previewText.style.fontSize = fontSize;
  elements.previewText.style.color = state.color;

  syncFullscreenPreview(elements);
}

function syncFullscreenPreview(elements) {
  const fullscreenText = elements.customizer.querySelector(
    ".embroidery-customizer__fullscreen-text",
  );
  const fullscreenLogo = elements.customizer.querySelector(
    ".embroidery-customizer__fullscreen-logo",
  );

  if (fullscreenText) {
    fullscreenText.innerHTML = elements.previewText.innerHTML;
    fullscreenText.style.fontFamily = elements.previewText.style.fontFamily;
    fullscreenText.style.fontSize = elements.previewText.style.fontSize;
    fullscreenText.style.color = elements.previewText.style.color;
    fullscreenText.style.left = elements.previewText.style.left;
    fullscreenText.style.top = elements.previewText.style.top;
    fullscreenText.style.transform = elements.previewText.style.transform;
  }

  if (fullscreenLogo) {
    fullscreenLogo.innerHTML = elements.previewLogo.innerHTML;
    fullscreenLogo.style.left = elements.previewLogo.style.left;
    fullscreenLogo.style.top = elements.previewLogo.style.top;
    fullscreenLogo.style.transform = elements.previewLogo.style.transform;
  }
}

function updatePreviewWithPlacement(state, elements) {
  if (state.selectedLogoImage || state.uploadedLogoImage) {
    elements.previewLogo.innerHTML = "";

    const logoImg = document.createElement("img");
    logoImg.src = state.uploadedLogoImage || state.selectedLogoImage;
    const containerWidth = elements.previewContainer.offsetWidth;
    const baseLogoSize = window.EmbroideryCustomizer.settings.logo_size || 150;
    const scaleFactor = containerWidth / 400; 
    const logoSize = (baseLogoSize * scaleFactor) + "px";
    logoImg.style.maxWidth = logoSize;
    logoImg.style.maxHeight = logoSize;
    logoImg.style.objectFit = "contain";

    elements.previewLogo.appendChild(logoImg);

    const logoCoords = state.logoPlacement === "left" 
      ? getPlacementCoords(window.EmbroideryCustomizer.product.leftPlacement)
      : getPlacementCoords(window.EmbroideryCustomizer.product.rightPlacement);
    applyPlacementStyles(elements.previewLogo, logoCoords);
  } else {
    elements.previewLogo.innerHTML = "";
  }

  if (state.numberOfLines > 0) {
    updatePreviewText(state, elements);
    
    const textCoords = state.textPlacement === "left"
      ? getPlacementCoords(window.EmbroideryCustomizer.product.leftPlacement)
      : getPlacementCoords(window.EmbroideryCustomizer.product.rightPlacement);
    
    applyPlacementStyles(elements.previewText, textCoords);
  } else {
    elements.previewText.innerHTML = "";
  }

  syncFullscreenPreview(elements);
}

/* =========================
   Logo Event Handling
========================= */

function setupLogoEventListeners(elements, state) {
  const categoryRadios = elements.logoOptions.querySelectorAll(
    ".logo-category-radio",
  );
  const categorySelects = elements.logoOptions.querySelectorAll(
    ".logo-category-select",
  );
  const positionCheckboxes =
    elements.logoOptions.querySelectorAll(".position-checkbox");

  categorySelects.forEach((select) => {
    select.value = "";
    select.disabled = true;
  });

  // Disable all position checkboxes initially
  positionCheckboxes.forEach((checkbox) => {
    checkbox.disabled = true;
  });

  // Hide all position sections initially
  elements.logoOptions
    .querySelectorAll(".logo-position-section")
    .forEach((section) => {
      section.hidden = true;
    });

  categoryRadios.forEach((radio) => {
    radio.addEventListener("change", (e) => {
      if (e.target.checked) {
        const logoCheckbox = elements.embroideryTypeCheckboxes[0];
        if (!logoCheckbox.checked) {
          logoCheckbox.checked = true;
        }

        const categoryIndex = e.target.dataset.categoryIndex;
        const categoryValue = e.target.value;
        const categoryItem = e.target.closest(".logo-category-item");
        const categoryPositionSection =
          categoryItem?.nextElementSibling?.classList.contains(
            "logo-position-section",
          )
            ? categoryItem.nextElementSibling
            : null;

        // Remove inactive class from this category name
        const categoryName = categoryItem?.querySelector(".logo-category-name");
        if (categoryName) {
          categoryName.classList.remove("inactive");
        }

        // Add inactive class to all other category names
        elements.logoOptions
          .querySelectorAll(".logo-category-name")
          .forEach((name) => {
            if (name !== categoryName) {
              name.classList.add("inactive");
            }
          });

        // Handle Upload Logo category
        if (categoryValue === "digitizing") {
          categorySelects.forEach((select) => {
            select.disabled = true;
            select.value = "";
          });

          // Hide all position sections
          elements.logoOptions
            .querySelectorAll(".logo-position-section")
            .forEach((section) => {
              section.hidden = true;
            });

          elements.logoOptions
            .querySelectorAll(".logo-category-preview")
            .forEach((preview) => {
              preview.style.backgroundImage = "";
            });

          // Show position section for digitizing and enable it
          if (categoryPositionSection) {
            categoryPositionSection.hidden = false;
            const positionCheckbox =
              categoryPositionSection.querySelector(".position-checkbox");
            if (positionCheckbox) {
              positionCheckbox.disabled = false;
            }
          }

          state.selectedCategories = {};
          state.selectedLogoImage = "";
          state.uploadedLogoImage = "digitizing";
          updateSummaryIndicator(state, elements);
          return;
        }

        if (categoryIndex !== undefined && categoryValue !== "upload") {
          const relatedSelect = elements.logoOptions.querySelector(
            `select[data-category-index="${categoryIndex}"]`,
          );

          categorySelects.forEach((select) => {
            select.disabled = true;
            select.value = "";
          });

          // Hide all position sections
          elements.logoOptions
            .querySelectorAll(".logo-position-section")
            .forEach((section) => {
              section.hidden = true;
            });

          elements.logoOptions
            .querySelectorAll(".logo-category-preview")
            .forEach((preview) => {
              preview.style.backgroundImage = "";
            });

          if (relatedSelect) {
            relatedSelect.disabled = false;
            state.selectedCategories[e.target.value] = "";

            // Show position section for this category, but keep checkbox disabled until logo is selected
            if (categoryPositionSection) {
              categoryPositionSection.hidden = false;
              const positionCheckbox =
                categoryPositionSection.querySelector(".position-checkbox");
              if (positionCheckbox) {
                positionCheckbox.disabled = true;
              }
            }
          }
        } else if (
          e.target.dataset.logoCategory === "none" ||
          e.target.value === "none"
        ) {
          categorySelects.forEach((select) => {
            select.disabled = true;
            select.value = "";
          });

          // Hide all position sections
          elements.logoOptions
            .querySelectorAll(".logo-position-section")
            .forEach((section) => {
              section.hidden = true;
            });

          elements.logoOptions
            .querySelectorAll(".logo-category-preview")
            .forEach((preview) => {
              preview.style.backgroundImage = "";
            });

          state.selectedCategories = {};
          state.selectedLogoImage = "";
          state.uploadedLogoImage = "";
         
          if (state.numberOfLines > 0) {
            elements.textPositionSection.hidden = false;
            state.textPlacement = "left";
            if (elements.textPositionCheckbox) {
              elements.textPositionCheckbox.checked = false;
              elements.textPositionCheckbox.disabled = false;
            }
          }
          updatePreviewWithPlacement(state, elements);
          updateSummaryIndicator(state, elements);
        }
      }
    });
  });

  categorySelects.forEach((select) => {
    select.addEventListener("change", (e) => {
      const categoryIndex = e.target.dataset.categoryIndex;
      const categoryRadio = elements.logoOptions.querySelector(
        `input.logo-category-radio[data-category-index="${categoryIndex}"]`,
      );
      const categoryItem = categoryRadio?.closest(".logo-category-item");
      const categoryPreview = categoryItem?.querySelector(
        ".logo-category-preview",
      );

      const selectedOption = e.target.querySelector(
        `option[value="${e.target.value}"]`,
      );
      const logoImage = selectedOption?.dataset.logoImage;
      const logoName = e.target.value;

      if (logoImage) {
        state.selectedLogoImage = logoImage;
        state.selectedLogoName = logoName;
        state.logoPlacement = getDefaultLogoPlacement(); // Set default placement
        state.textPlacement = state.logoPlacement === "left" ? "right" : "left"; // Opposite of logo placement

        if (state.numberOfLines > 0) {
          elements.textPositionSection.hidden = true;
          if (elements.textPositionCheckbox) {
            elements.textPositionCheckbox.disabled = true;
          }
        }

        if (categoryPreview) {
          categoryPreview.style.backgroundImage = `url('${logoImage}')`;
          categoryPreview.style.backgroundSize = "contain";
          categoryPreview.style.backgroundRepeat = "no-repeat";
          categoryPreview.style.backgroundPosition = "center";
        }

        // Reset position checkbox to default placement
        const positionCheckbox = elements.logoOptions.querySelector(
          `input.position-checkbox[data-category-index="${categoryIndex}"]`,
        );
        if (positionCheckbox) {
          positionCheckbox.checked = state.logoPlacement === "right";
          positionCheckbox.disabled = false;
        }

        updatePreviewWithPlacement(state, elements);

        if (categoryRadio) {
          state.selectedCategories = {};
          state.selectedCategories[categoryRadio.value] = e.target.value;
        }
        
        updateSummaryIndicator(state, elements);
      } else if (e.target.value === "") {
        if (categoryPreview) {
          categoryPreview.style.backgroundImage = "";
        }
        state.selectedLogoImage = "";

        // Disable position checkbox when no logo selected
        const positionCheckbox = elements.logoOptions.querySelector(
          `input.position-checkbox[data-category-index="${categoryIndex}"]`,
        );
        if (positionCheckbox) {
          positionCheckbox.disabled = true;
        }

        // Show text position section when logo is deselected
        if (state.numberOfLines > 0) {
          elements.textPositionSection.hidden = false;
          state.textPlacement = "left";
          if (elements.textPositionCheckbox) {
            elements.textPositionCheckbox.checked = false;
            elements.textPositionCheckbox.disabled = false;
          }
        }

        updatePreviewWithPlacement(state, elements);
        updateSummaryIndicator(state, elements);
      }
    });
  });

  positionCheckboxes.forEach((checkbox) => {
    const updateLabelVisibility = () => {
      const toggle = checkbox.closest(".logo-position-section");
      if (toggle) {
        const leftLabel = toggle.querySelector(".position-label-left");
        const rightLabel = toggle.querySelector(".position-label-right");

        if (checkbox.checked) {
          leftLabel?.style.setProperty("display", "none");
          rightLabel?.style.setProperty("display", "inline");
        } else {
          leftLabel?.style.setProperty("display", "inline");
          rightLabel?.style.setProperty("display", "none");
        }
      }
    };

    updateLabelVisibility();

    checkbox.addEventListener("change", (e) => {
      // Checkbox checked = Right, Checkbox unchecked = Left
      state.logoPlacement = e.target.checked ? "right" : "left";
      state.textPlacement = state.logoPlacement === "left" ? "right" : "left";
      updateLabelVisibility();
      updatePreviewWithPlacement(state, elements);
    });
  });

  // Handle logo upload
  const uploadInput = elements.logoOptions?.querySelector(".logo-upload-input");
  const uploadButton = elements.logoOptions?.querySelector(
    ".logo-upload-button",
  );
  const uploadFilename = elements.logoOptions?.querySelector(
    ".logo-upload-filename",
  );
  const uploadPreview = elements.logoOptions?.querySelector(
    ".logo-upload-preview",
  );
  const uploadRadio = elements.logoOptions?.querySelector(
    "input[value='upload']",
  );

  if (uploadInput && uploadButton) {
    uploadInput.addEventListener("change", (e) => {
      const file = e.target.files[0];
      if (file) {
        // Create FormData and upload to endpoint
        const formData = new FormData();
        formData.append("file", file);

        // Upload to internal endpoint
        fetch("/apps/embroidery/upload", {
          method: "POST",
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.url) {
              state.uploadedLogoImage = data.url;
              state.logoPlacement = getDefaultLogoPlacement(); // Set default placement
              state.textPlacement = state.logoPlacement === "left" ? "right" : "left"; // Opposite of logo placement

              // Hide text position section when logo is selected
              if (state.numberOfLines > 0) {
                elements.textPositionSection.hidden = true;
                if (elements.textPositionCheckbox) {
                  elements.textPositionCheckbox.disabled = true;
                }
              }

              // Update preview
              if (uploadPreview) {
                uploadPreview.style.backgroundImage = `url('${data.url}')`;
                uploadPreview.style.backgroundSize = "contain";
                uploadPreview.style.backgroundRepeat = "no-repeat";
                uploadPreview.style.backgroundPosition = "center";
              }

              // Update filename display
              if (uploadFilename) {
                uploadFilename.textContent = file.name;
              }

              // Enable position checkbox for upload
              const uploadPositionCheckbox =
                elements.logoOptions?.querySelector(
                  "input.position-checkbox[data-category-index='upload']",
                );
              if (uploadPositionCheckbox) {
                uploadPositionCheckbox.checked = state.logoPlacement === "right";
                uploadPositionCheckbox.disabled = false;
              }

              // Select upload radio
              if (uploadRadio) {
                uploadRadio.checked = true;
              }

              updatePreviewWithPlacement(state, elements);
              updateSummaryIndicator(state, elements);
            } else {
              console.error("Upload failed:", data.error);
              if (uploadFilename) {
                uploadFilename.textContent = "Upload failed";
                uploadFilename.style.color = "red";
              }
            }
          })
          .catch((error) => {
            console.error("Upload error:", error);
            if (uploadFilename) {
              uploadFilename.textContent = "Upload error";
              uploadFilename.style.color = "red";
            }
          });
      }
    });
  }
}

/* =========================
   Fullscreen Preview Handlers
========================= */

function setupFullscreenPreview(elements, state) {
  const expandButton = elements.customizer.querySelector(
    ".embroidery-customizer__preview-expand",
  );
  const fullscreenModal = elements.customizer.querySelector(
    ".embroidery-customizer__fullscreen-modal",
  );
  const closeButton = elements.customizer.querySelector(
    ".embroidery-customizer__fullscreen-close",
  );
  const fullscreenText = elements.customizer.querySelector(
    ".embroidery-customizer__fullscreen-text",
  );
  const fullscreenLogo = elements.customizer.querySelector(
    ".embroidery-customizer__fullscreen-logo",
  );

  if (!expandButton || !fullscreenModal || !closeButton) {
    return;
  }

  const openFullscreen = () => {
    fullscreenModal.removeAttribute("hidden");
    document.body.style.overflow = "hidden";

    if (fullscreenText) {
      fullscreenText.innerHTML = elements.previewText.innerHTML;
      fullscreenText.style.fontFamily = elements.previewText.style.fontFamily;
      fullscreenText.style.fontSize = elements.previewText.style.fontSize;
      fullscreenText.style.color = elements.previewText.style.color;
      fullscreenText.style.left = elements.previewText.style.left;
      fullscreenText.style.top = elements.previewText.style.top;
      fullscreenText.style.transform = elements.previewText.style.transform;
    }

    if (fullscreenLogo) {
      fullscreenLogo.innerHTML = elements.previewLogo.innerHTML;
      fullscreenLogo.style.left = elements.previewLogo.style.left;
      fullscreenLogo.style.top = elements.previewLogo.style.top;
      fullscreenLogo.style.transform = elements.previewLogo.style.transform;
      
    }
  };

  const closeFullscreen = () => {
    fullscreenModal.setAttribute("hidden", "");
    document.body.style.overflow = "";
  };

  expandButton.addEventListener("click", openFullscreen);
  closeButton.addEventListener("click", closeFullscreen);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !fullscreenModal.hasAttribute("hidden")) {
      closeFullscreen();
    }
  });

  fullscreenModal.addEventListener("click", (e) => {
    if (e.target === fullscreenModal) {
      closeFullscreen();
    }
  });
}

/* =========================
   Info Modal Handlers
========================= */

function setupInfoModal(embroideryCustomizer) {
  // Find info modal and button - they're siblings within the same parent
  const parent = embroideryCustomizer.parentElement;
  const infoButton = parent?.querySelector(".embroidery-customizer__info-button");
  const infoModal = parent?.querySelector(".embroidery-customizer__info-modal");
  const closeButton = infoModal?.querySelector(".embroidery-customizer__info-close");
  const overlay = infoModal?.querySelector(".embroidery-customizer__info-overlay");

  if (!infoButton || !infoModal || !closeButton) {
    // Fallback: search document if parent search fails
    const fallbackButton = document.querySelector(".embroidery-customizer__info-button");
    const fallbackModal = document.querySelector(".embroidery-customizer__info-modal");
    if (!fallbackButton || !fallbackModal) return;
    setupInfoModalEvents(fallbackButton, fallbackModal, fallbackModal.querySelector(".embroidery-customizer__info-close"), fallbackModal.querySelector(".embroidery-customizer__info-overlay"));
    return;
  }

  setupInfoModalEvents(infoButton, infoModal, closeButton, overlay);
}

function setupInfoModalEvents(infoButton, infoModal, closeButton, overlay) {
  const openModal = () => {
    infoModal.removeAttribute("hidden");
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    infoModal.setAttribute("hidden", "");
    document.body.style.overflow = "";
  };

  infoButton.addEventListener("click", openModal);
  closeButton.addEventListener("click", closeModal);
  overlay?.addEventListener("click", closeModal);

  // Close on Escape key
  const escapeHandler = (e) => {
    if (e.key === "Escape" && !infoModal.hasAttribute("hidden")) {
      closeModal();
    }
  };
  document.addEventListener("keydown", escapeHandler);
}

/* =========================
   Dynamic Checkout Interceptor
========================= */

function setupDynamicCheckoutInterceptor(productForm, state, elements) {
  if (!productForm) return;

  const dynamicPaymentContainer = document.querySelector('.product-dynamic-payment-button');
  if (!dynamicPaymentContainer) return;

  // Use event delegation to capture clicks on dynamically rendered Shop Pay buttons
  dynamicPaymentContainer.addEventListener('click', async (e) => {
    const hasCustomization = state.numberOfLines > 0 || state.hasLogo;
    
    if (!hasCustomization) return;

    const shopPayButton = e.target.closest('.shopify-payment-button__button, [data-testid="ShopifyPayButton"], shopify-accelerated-checkout, shopify-buy-it-now-button');
    if (!shopPayButton) return;

    e.preventDefault();
    e.stopPropagation();

    // Add embroidery products to cart first
    await addEmbroideryProductsForCheckout(productForm, state);

    // After adding products, redirect to checkout
    window.location.href = '/checkout';
  }, true);

  // Also observe for dynamically added buttons (Shop Pay loads asynchronously)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const shopPayElements = node.querySelectorAll?.('.shopify-payment-button__button, shopify-accelerated-checkout, shopify-buy-it-now-button') || [];
          shopPayElements.forEach((btn) => {
            btn.addEventListener('click', async (e) => {
              const hasCustomization = state.numberOfLines > 0 || state.hasLogo;
              if (!hasCustomization) return;

              e.preventDefault();
              e.stopPropagation();
              await addEmbroideryProductsForCheckout(productForm, state);
              window.location.href = '/checkout';
            }, true);
          });
        }
      });
    });
  });

  observer.observe(dynamicPaymentContainer, { childList: true, subtree: true });
}

async function addEmbroideryProductsForCheckout(form, state) {
  const variantIdInput = form.querySelector('input[name="id"]');
  const quantityInput = form.querySelector('input[name="quantity"]');

  const variantId = variantIdInput ? parseInt(variantIdInput.value) : null;
  const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

  if (!variantId) {
    console.error("Could not find variant ID in form");
    return;
  }

  const lineCountNum = state.numberOfLines;
  const lineWords = ["", "one", "two", "three"];

  const baseProductItem = {
    id: variantId,
    quantity: quantity,
  };

  const hasCustomization = state.numberOfLines > 0 || (state.selectedLogoImage || state.uploadedLogoImage);
  if (hasCustomization) {
    baseProductItem.properties = getEmbroideryProperties(state);
  }

  const items = [baseProductItem];

  // Add embroidery products if text exists
  if (state.numberOfLines > 0) {
    const variantIdKey = `${lineWords[lineCountNum]}_line_product_id`;
    const embroideryVariantId = window.EmbroideryCustomizer.settings[variantIdKey];

    if (embroideryVariantId) {
      items.push({
        id: embroideryVariantId,
        quantity: quantity,
        properties: {
          "Type": "Text Embroidery"
        },
        parent_id: variantId,
      });
    }
  }

  if (state.selectedLogoImage) {
    const logoVariantId = window.EmbroideryCustomizer.settings.logo_product_id;

    if (logoVariantId) {
      items.push({
        id: logoVariantId,
        quantity: quantity,
        properties: {
          "Type": "Standard Logo"
        },
        parent_id: variantId,
      });
    }
  }

  if (state.uploadedLogoImage) {
    const uploadLogoVariantId = window.EmbroideryCustomizer.settings.logo_upload_product_id;

    if (uploadLogoVariantId) {
      items.push({
        id: uploadLogoVariantId,
        quantity: quantity,
        properties: {
          "Type": "Logo Digitizing Service"
        },
        parent_id: variantId,
      });
    }
  }

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: items }),
    });
    return await response.json();
  } catch (error) {
    console.error("Error adding embroidery products for checkout:", error);
    throw error;
  }
}

/* =========================
   Customizer Initialization
========================= */

function initializeCustomizer(embroideryCustomizer) {
  const elements = {
    customizer: embroideryCustomizer,
    embroideryTypeCheckboxes: embroideryCustomizer.querySelectorAll(
      'input[type="checkbox"].embroidery-type-checkbox',
    ),
    logoOptions: embroideryCustomizer.querySelector(
      ".embroidery-customizer__logo-options",
    ),
    embroideryOptions: embroideryCustomizer.querySelector(
      ".embroidery-customizer__embroidery-options",
    ),
    embroideryOptionsRadios: embroideryCustomizer.querySelectorAll(
      'input[type="radio"][data-embroidery-line]',
    ),
    embroideryLineInputsContainer:
      embroideryCustomizer.querySelector(".line-inputs"),
    fontSelector: embroideryCustomizer.querySelector("#font"),
    embroideryLineInputs: embroideryCustomizer.querySelectorAll(".line-input"),
    settings: embroideryCustomizer.querySelector(".embroidery-settings"),
    preview: embroideryCustomizer.querySelector(
      ".embroidery-customizer__preview",
    ),
    previewImage: embroideryCustomizer.querySelector(
      ".embroidery-customizer__preview-image",
    ),
    previewText: embroideryCustomizer.querySelector(
      ".embroidery-customizer__preview-text",
    ),
    previewLogo: embroideryCustomizer.querySelector(
      ".embroidery-customizer__preview-logo",
    ),
    previewContainer: embroideryCustomizer.querySelector(
      ".embroidery-customizer__preview-container",
    ),
    disclaimer: document.querySelector(".embroidery-customizer__disclaimer"),
    textPositionSection: embroideryCustomizer.querySelector(".text-position-section"),
    textPositionCheckbox: embroideryCustomizer.querySelector(".text-position-checkbox"),
  };

  const state = {
    hasLogo: false,
    hasEmbroidery: false,
    logoPlacement: getDefaultLogoPlacement(),
    textPlacement: "right",
    color: "Black",
    selectedLogoImage: "",
    uploadedLogoImage: "",
    selectedCategories: {},
    textLines: {
      line1: "",
      line2: "",
      line3: "",
    },
    numberOfLines: 0,
    font: window.EmbroideryCustomizer.embroidery.fonts[0]?.name || "Arial",
    productId: window.EmbroideryCustomizer.product.id,
    currentQuantity: 1,
  };

  let hasBeenInitialized = false;

  window.EmbroideryCustomizer.addedVariantIds = [];

  resetUIOnLoad(elements);

  elements.fontSelector.style.fontFamily = `'${state.font}'`;

  const colorCircle = embroideryCustomizer.querySelector("#color-circle");
  const colorSelector = embroideryCustomizer.querySelector("#color");

  if (colorCircle && colorSelector && colorSelector.options[0]) {
    const firstColorValue = colorSelector.options[0].getAttribute("data-color");
    if (firstColorValue) {
      colorCircle.style.backgroundColor = firstColorValue;
      state.color = firstColorValue; 
    }
  }

  if (colorSelector) {
    colorSelector.addEventListener("change", (event) => {
      const selectedOption = event.target.options[event.target.selectedIndex];
      const colorValue = selectedOption.getAttribute("data-color");
      state.color = colorValue || event.target.value;
      updatePreviewText(state, elements);

      if (colorCircle) {
        if (colorValue) {
          colorCircle.style.backgroundColor = colorValue;
        }
      }
    });
  }

  // Text position toggle event listener
  if (elements.textPositionCheckbox) {
    elements.textPositionCheckbox.addEventListener("change", (e) => {
      // Checkbox checked = Right, Checkbox unchecked = Left
      state.textPlacement = e.target.checked ? "right" : "left";
      updatePreviewWithPlacement(state, elements);
    });
  }

  // Embroidery type checkboxes - allow both to be selected
  elements.embroideryTypeCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", (event) => {
      const type = event.target.dataset.embroideryType;
      if (event.target.checked) {
        if (type === "logo") {
          state.hasLogo = true;
        } else if (type === "embroidery") {
          state.hasEmbroidery = true;
        }
        if (!hasBeenInitialized) {
          elements.embroideryTypeCheckboxes.forEach((cb) => {
            cb.checked = true;
          });
          state.hasLogo = true;
          state.hasEmbroidery = true;

          const embroideryNoneRadio = elements.embroideryOptions.querySelector('input[data-embroidery-line="0"]');
          if (embroideryNoneRadio) {
            embroideryNoneRadio.checked = true;
            state.numberOfLines = 0;
          }
          
          const logoNoneRadio = elements.logoOptions.querySelector('input[value="none"]');
          if (logoNoneRadio) {
            logoNoneRadio.checked = true;
            state.selectedLogoImage = "";
            state.uploadedLogoImage = "";
          }
          
          elements.textPositionSection.hidden = true;
          if (elements.textPositionCheckbox) {
            elements.textPositionCheckbox.disabled = true;
          }
          
          hasBeenInitialized = true;
        }
      } else {
        if (type === "logo") {
          state.hasLogo = false;
        } else if (type === "embroidery") {
          state.hasEmbroidery = false;
        }
      }
      
      elements.logoOptions.hidden = !state.hasLogo;
      elements.embroideryOptions.hidden = !state.hasEmbroidery;
      
      // Show/hide disclaimer based on logo selection
      if (elements.disclaimer) {
        if (state.hasLogo) {
          elements.disclaimer.classList.add("is-visible");
        } else {
          elements.disclaimer.classList.remove("is-visible");
        }
      }
      
      // Always show preview if there's any customization
      const isCustomizationSelected = state.hasLogo || state.hasEmbroidery;
      const showPreview = window.EmbroideryCustomizer?.product?.showPreview !== false;
      elements.preview.hidden = !isCustomizationSelected || !showPreview;
      
      if (isCustomizationSelected) {
        elements.previewImage.style.transform = "scale(2)";
        // Update preview to show both customizations (preserve both elements)
        updatePreviewWithPlacement(state, elements);
      } else {
        // Only clear preview if nothing is selected
        elements.previewText.innerHTML = "";
        elements.previewLogo.innerHTML = "";
      }
    });
  });

  elements.embroideryOptionsRadios.forEach((option, idx) => {
    option.addEventListener("change", (event) => {
      const newLineCount = event.target.dataset.embroideryLine;
      const embroideryCheckbox = elements.embroideryTypeCheckboxes[1];

      if (!embroideryCheckbox.checked) {
        embroideryCheckbox.checked = true;
      }

      if (newLineCount > 0) {
        elements.settings.hidden = false;
      } else {
        elements.settings.hidden = true;
      }

      if (state.numberOfLines.toString() === newLineCount) return;
      changeNumberOfLines(state, elements, option);
      updateHelpTextVisibility(state, elements);
    });
  });

  elements.fontSelector.addEventListener("change", (event) => {
    const newFont = event.target.value;

    if (state.font === newFont) return;

    state.font = newFont;

    elements.fontSelector.style.fontFamily = `'${newFont}'`;
    updatePreviewText(state, elements);
  });

  const lineInputElements = embroideryCustomizer.querySelectorAll(
    '.line-input input[type="text"]',
  );

  lineInputElements.forEach((input, idx) => {
    input.addEventListener("input", (event) => {
      const lineKey = `line${idx + 1}`;
      state.textLines[lineKey] = event.target.value;
      updatePreviewText(state, elements);
      updateHelpTextVisibility(state, elements);
      updateSummaryIndicator(state, elements);
    });
  });

  const logoPlacementRadios = embroideryCustomizer.querySelectorAll(
    'input[name="logoPlacement"]',
  );
  logoPlacementRadios.forEach((radio) => {
    radio.addEventListener("change", (event) => {
      state.logoPlacement = event.target.value;
      updatePreviewWithPlacement(state, elements);
    });
  });

  const quantityInput = document.querySelector('input[name="quantity"]');
  if (quantityInput) {
    quantityInput.addEventListener("change", (event) => {
      const newQuantity = parseInt(event.target.value) || 1;
      state.currentQuantity = newQuantity;

      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          const embroideryVariantIds = [
            window.EmbroideryCustomizer.settings.one_line_product_id,
            window.EmbroideryCustomizer.settings.two_line_product_id,
            window.EmbroideryCustomizer.settings.three_line_product_id,
            window.EmbroideryCustomizer.settings.logo_product_id,
            window.EmbroideryCustomizer.settings.logo_upload_product_id,
          ];

          cart.items.forEach((item) => {
            if (embroideryVariantIds.includes(item.variant_id)) {
              updateEmbroideryProductQuantity(item.variant_id, newQuantity);
            }
          });
        })
        .catch((error) =>
          console.error("Error updating embroidery quantities:", error),
        );
    });
  }

  const productForm = document.querySelector(".js-product-form");
  if (productForm) {
    productForm.addEventListener("submit", function (e) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    productForm.addEventListener("click", function (e) {
      const button = e.target.closest('button[type="submit"], [name="add"]');
      if (!button) return;

      e.preventDefault();
      e.stopPropagation();

      const hasCustomization = state.numberOfLines > 0 || state.hasLogo || state.uploadedLogoImage;

      const fontHiddenInput = productForm.querySelector("#font-property");
      const colorHiddenInput = productForm.querySelector("#color-property");

      if (hasCustomization) {
        if (fontHiddenInput) {
          fontHiddenInput.value = state.font;
          fontHiddenInput.disabled = false;
        }
        if (colorHiddenInput) {
          colorHiddenInput.value = state.color;
          colorHiddenInput.disabled = false;
        }
      } else {
        if (fontHiddenInput) fontHiddenInput.disabled = true;
        if (colorHiddenInput) colorHiddenInput.disabled = true;
      }

      addProductsToCart(productForm, state, elements, () => {
        hasBeenInitialized = false;
      });
    });
  }

  // Intercept Shop Pay / Dynamic Checkout buttons
  setupDynamicCheckoutInterceptor(productForm, state, elements);

  setupLogoEventListeners(elements, state);
  setupFullscreenPreview(elements, state);
  setupInfoModal(embroideryCustomizer);
}

/* =========================
   Add Products to Cart
========================= */

async function addProductsToCart(form, state, elements, onSuccess) {
  const productFormEl = form.closest('product-form') || document.querySelector('product-form');
  const variantIdInput = productFormEl?.querySelector('input[name="id"]') || form.querySelector('input[name="id"]');
  const quantityInput = productFormEl?.querySelector('input[name="quantity"]') || form.querySelector('input[name="quantity"]');

  const variantId = variantIdInput ? parseInt(variantIdInput.value) : null;
  const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

  if (!variantId) {
    console.error("Could not find variant ID in form", { form, productFormEl, variantIdInput });
    return;
  }

  // Inventory check before submitting
  const lineCountNum = state.numberOfLines;
  const lineWords = ["", "one", "two", "three"];

  const baseProductItem = {
    id: variantId,
    quantity: quantity,
  };

  // Add all customization properties to base product if customization exists
  const hasCustomization =
    state.numberOfLines > 0 || (state.selectedLogoImage || state.uploadedLogoImage);
  if (hasCustomization) {
    baseProductItem.properties = getEmbroideryProperties(state);
  }

  const items = [baseProductItem];

  // Add embroidery products if text exists (regardless of checkbox state)
  if (state.numberOfLines > 0) {
    const variantIdKey = `${lineWords[lineCountNum]}_line_product_id`;
    const embroideryVariantId =
      window.EmbroideryCustomizer.settings[variantIdKey];

    if (embroideryVariantId) {
      items.push({
        id: embroideryVariantId,
        quantity: quantity,
        properties: { "Type": "Text Embroidery" },
        parent_id: variantId,
      });
    }
  }

  if (state.selectedLogoImage) {
    const logoVariantId = window.EmbroideryCustomizer.settings.logo_product_id;

    if (logoVariantId) {
      items.push({
        id: logoVariantId,
        quantity: quantity,
        properties: { "Type": "Standard Logo" },
        parent_id: variantId,
      });
    }
  }

  if (state.uploadedLogoImage) {
    const uploadLogoVariantId =
      window.EmbroideryCustomizer.settings.logo_upload_product_id;

    if (uploadLogoVariantId) {
      items.push({
        id: uploadLogoVariantId,
        quantity: quantity,
        properties: {
          "Type": state.uploadedLogoImage === "digitizing" ? "Logo Digitizing" : "Custom Logo Upload"
        },
        parent_id: variantId,
      });
    }
  }

  // Add all products in one request
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    });

    const data = await response.json();
    if (!response.ok) throw data;

    // Clear any inventory error message on success
    const errorDiv = form.closest('product-form')?.querySelector('.js-form-error');
    if (errorDiv) {
      errorDiv.hidden = true;
      errorDiv.textContent = '';
    }

    // Refresh and open cart drawer
    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true }));
    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:open", { bubbles: true }));

    // Reset state and UI
    resetState(state);
    onSuccess();

    // Close the details dropdown
    const embroideryDetailsElement = elements.customizer.closest('details');
    if (embroideryDetailsElement) {
      embroideryDetailsElement.removeAttribute('open');
    }

    elements.embroideryTypeCheckboxes.forEach((checkbox) => (checkbox.checked = false));
    elements.embroideryOptionsRadios.forEach((radio) => (radio.checked = false));

    if (elements.textPositionCheckbox) {
      elements.textPositionCheckbox.checked = true;
    }

    elements.logoOptions.querySelectorAll(".logo-category-radio").forEach((radio) => { radio.checked = false; });
    elements.logoOptions.querySelectorAll(".logo-category-select").forEach((select) => { select.value = ""; select.disabled = true; });
    elements.logoOptions.querySelectorAll(".position-checkbox").forEach((checkbox) => { checkbox.checked = getDefaultLogoPlacement() === "right"; checkbox.disabled = true; });
    elements.logoOptions.querySelectorAll(".logo-category-preview").forEach((preview) => { preview.style.backgroundImage = ""; });

    const uploadInput = elements.logoOptions?.querySelector(".logo-upload-input");
    const uploadFilename = elements.logoOptions?.querySelector(".logo-upload-filename");
    if (uploadInput) uploadInput.value = "";
    if (uploadFilename) uploadFilename.textContent = "";

    elements.embroideryLineInputs.forEach((line) => {
      const input = line.querySelector("input");
      if (input) input.value = "";
    });

    elements.fontSelector.value = window.EmbroideryCustomizer.embroidery.fonts[0]?.name || "Arial";
    elements.fontSelector.style.fontFamily = `'${state.font}'`;

    elements.previewText.innerHTML = "";
    elements.previewLogo.innerHTML = "";

    const uploadPreview = elements.logoOptions?.querySelector(".logo-upload-preview");
    if (uploadPreview) {
      uploadPreview.innerHTML = "";
      uploadPreview.style.backgroundImage = "";
    }

    elements.preview.hidden = true;
    elements.settings.hidden = true;
    elements.logoOptions.hidden = true;
    elements.embroideryOptions.hidden = true;
    elements.embroideryLineInputsContainer.hidden = true;

    elements.embroideryLineInputs.forEach((line) => { line.hidden = true; });

    elements.logoOptions.querySelectorAll(".logo-position-section").forEach((section) => { section.hidden = true; });

    updatePreviewWithPlacement(state, elements);
    updateSummaryIndicator(state, elements);

    document.dispatchEvent(new CustomEvent("embroidery:products-added", { detail: { cartData: data } }));

   } catch (error) {
    console.error("Error adding products:", error);

    // Show inventory/availability error message inline
    const errorDiv = form.closest('product-form')?.querySelector('.js-form-error');
    if (errorDiv && error.description) {
      const isAvailabilityError = error.description.toLowerCase().includes('maximum') ||
                                  error.description.toLowerCase().includes('availability');
      if (isAvailabilityError) {
        errorDiv.textContent = error.description;
        errorDiv.hidden = false;
        errorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    // Unstick cart state after failed add so subsequent attempts work
    try {
      const cartData = await fetch('/cart.js').then(r => r.json());
      const updates = {};
      cartData.items.forEach(item => { updates[item.key] = item.quantity; });
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      document.dispatchEvent(new CustomEvent("on:cart:change", { bubbles: true }));
    } catch (e) {
      // If unstick fails, page reload will recover
    }

    document.dispatchEvent(new CustomEvent("embroidery:form-error", { detail: { error: error } }));
  }
}